// extracted by mini-css-extract-plugin
export default {"indicatorContent":"Indicator_indicatorContent__jwnu4","border":"Indicator_border__aFL6W","indicatorContainer":"Indicator_indicatorContainer__9wWky"};